import React, { useState, useMemo, useCallback } from "react";
import { Select, Button } from 'antd';
import { MenuOutlined  } from "@ant-design/icons";
import { DeleteOutlined } from '@ant-design/icons';
import { isValid, isValidBool } from './../../../utils/utilities'
import { useSelector } from "react-redux";
import { selectedCitiesSelector } from "../../../selector/trip-create.selector";

const { Option } = Select;

export const CitySelect = React.memo((props) => {
    const {
        masterCities,
        cityIndex,
        updateSelectedCity,
        disabled,
        defaultCity,
        selectedMethod='map',
        selectedCities,
        isOrigin,
        isDestination
    }= props;

    // State to track if dropdown is open and options should be generated
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    // Use useCallback for event handlers to prevent unnecessary re-renders
    const onChange = useCallback((value, info) => {
        updateSelectedCity(cityIndex, info);
    }, [updateSelectedCity, cityIndex]);

    const handleDelete = useCallback(() => {
        updateSelectedCity(cityIndex, null);
    }, [updateSelectedCity, cityIndex]);

    // Handle dropdown visibility change to control when options are generated
    const onDropdownVisibleChange = useCallback((open) => {
        setIsDropdownOpen(open);
    }, []);

    // Memoize the filtered options - only generate when dropdown is open
    const filteredOptions = useMemo(() => {
        if (!isDropdownOpen) return [];
        return masterCities
            .filter(item => {
                return !selectedCities.some(selectedCity => (selectedCity.city_name == item.city_name)||(selectedCity.city_name == item.alias_city_name));
            })
            .map(item => (
                <Option key={item.id} value={item.city_name} data={item}>
                    {item.city_name}{isValid(item.alias_city_name) ? " / " + item.alias_city_name : null}
                </Option>
            ));
    }, [isDropdownOpen, masterCities, selectedCities]);

    // Memoize the origin/destination setter functions
    const setOriginDestination = useCallback((buttonType, value) => {
        let cityInfo = selectedCities.find(selectedCity => selectedCity.city_name === defaultCity);
        if(isValid(cityInfo)){
            // Create a new object to avoid mutation
            const updatedCityInfo = {
                ...cityInfo,
                [buttonType]: value
            };
            updateSelectedCity(cityIndex,{'data':updatedCityInfo});
        }
    }, [selectedCities, defaultCity, updateSelectedCity, cityIndex]);

    const deleteProps = useMemo(() => (
        <div className="marginLeft">
            <DeleteOutlined
                onClick={handleDelete}
                style={{
                    fontSize: 16
                }}
                />
        </div>
    ), [handleDelete]);



    return (
        <div className="city-select-root">
                <div className="city-number">
                    {cityIndex+1}
                </div>
               <Select
                    suffixIcon={selectedMethod=="map"?<MenuOutlined />:null}
                    showSearch
                    size="large"
                    style= {{backgroundColor: 'white',width: 200}}
                    placeholder="Select a city"
                    optionFilterProp="children"
                    onChange={onChange}
                    onDropdownVisibleChange={onDropdownVisibleChange}
                    disabled= {disabled}
                    value = {defaultCity}
                    >
                        {filteredOptions}
                    </Select>
                    {selectedMethod !== 'time'? cityIndex !== selectedCities.length && deleteProps:
                    <div className="marginLeft" style={{display: 'flex', alignItems: 'center'}}>
                        <Button type="primary" style={{ background: isOrigin ? '#20b486' : '#e0e0e0', color: isOrigin ? '#fff' : '#333', border: 'none' }} disabled={!defaultCity} onClick={()=>setOriginDestination('isOrigin', !isOrigin)}>O</Button>
                        <Button type="primary" style={{ marginLeft:10, background: isDestination ? '#ff6b6b' : '#e0e0e0', color: isDestination ? '#fff' : '#333', border: 'none' }} disabled={!defaultCity} onClick={()=>setOriginDestination('isDestination', !isDestination)}>D</Button>
                        {deleteProps}
                        <MenuOutlined style={{marginLeft:10}}/>
                    </div>}
        </div>
    )
}, (prevProps, nextProps) => {
    // Custom comparison function for React.memo
    // Only re-render if these props have changed
    return (
        prevProps.cityIndex === nextProps.cityIndex &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.defaultCity === nextProps.defaultCity &&
        prevProps.selectedMethod === nextProps.selectedMethod &&
        prevProps.masterCities === nextProps.masterCities &&
        prevProps.updateSelectedCity === nextProps.updateSelectedCity
    );
});

// Add display name for better debugging
CitySelect.displayName = 'CitySelect';
